<template>
  <div :class="{ 'error': !!errorMsg }">
    <div v-if="label" class="mb-1 font-medium flex gap-1 items-center">
      {{ label }}
      <span v-if="required" class="text-red-600">*</span>
      <UiIcon v-if="tooltip" v-tooltip icon="info-circle" size="1em" :title="tooltip" />
    </div>
    <slot />
    <pe-error-msg :message="errorMsg" />
  </div>
</template>

<script setup lang="ts">
import UiIcon from '@/components/ui/icon.vue'
defineProps<{
  label?: string
  required?: boolean
  tooltip?: string
  errorMsg?: string
}>()
</script>

<style scoped>

</style>